// Attribution: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react#sign-users-out

// Dependencies
import React, { useCallback } from "react";
import { useNavigate } from "react-router";

// Material
import Button from "@mui/material/Button";

/**
 * Renders a button which, when selected, will redirect the page to the logout prompt
 */
const SignOutButton: React.FC = () => {
  const navigate = useNavigate();

  // Signout button click event handler
  const handleLogout = useCallback(() => {
    navigate("/signout");
  }, [navigate]);

  return (
    <Button
      size="small"
      type="button"
      variant="outlined"
      color="primary"
      onClick={handleLogout}
    >
      Sign Out
    </Button>
  );
};

export { SignOutButton };
